/******/ (function (modules) {
  // webpackBootstrap
  /******/ // The module cache
  /******/ var installedModules = {};
  /******/
  /******/ // The require function
  /******/ function __webpack_require__(moduleId) {
    /******/
    /******/ // Check if module is in cache
    /******/ if (installedModules[moduleId]) {
      /******/ return installedModules[moduleId].exports;
      /******/
    }
    /******/ // Create a new module (and put it into the cache)
    /******/ var module = (installedModules[moduleId] = {
      /******/ i: moduleId,
      /******/ l: false,
      /******/ exports: {},
      /******/
    });
    /******/
    /******/ // Execute the module function
    /******/ modules[moduleId].call(
      module.exports,
      module,
      module.exports,
      __webpack_require__,
    );
    /******/
    /******/ // Flag the module as loaded
    /******/ module.l = true;
    /******/
    /******/ // Return the exports of the module
    /******/ return module.exports;
    /******/
  }
  /******/
  /******/
  /******/ // expose the modules object (__webpack_modules__)
  /******/ __webpack_require__.m = modules;
  /******/
  /******/ // expose the module cache
  /******/ __webpack_require__.c = installedModules;
  /******/
  /******/ // define getter function for harmony exports
  /******/ __webpack_require__.d = function (exports, name, getter) {
    /******/ if (!__webpack_require__.o(exports, name)) {
      /******/ Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter,
      });
      /******/
    }
    /******/
  };
  /******/
  /******/ // define __esModule on exports
  /******/ __webpack_require__.r = function (exports) {
    /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
      /******/ Object.defineProperty(exports, Symbol.toStringTag, {
        value: "Module",
      });
      /******/
    }
    /******/ Object.defineProperty(exports, "__esModule", { value: true });
    /******/
  };
  /******/
  /******/ // create a fake namespace object
  /******/ // mode & 1: value is a module id, require it
  /******/ // mode & 2: merge all properties of value into the ns
  /******/ // mode & 4: return value when already ns object
  /******/ // mode & 8|1: behave like require
  /******/ __webpack_require__.t = function (value, mode) {
    /******/ if (mode & 1) value = __webpack_require__(value);
    /******/ if (mode & 8) return value;
    /******/ if (
      mode & 4 &&
      typeof value === "object" &&
      value &&
      value.__esModule
    )
      return value;
    /******/ var ns = Object.create(null);
    /******/ __webpack_require__.r(ns);
    /******/ Object.defineProperty(ns, "default", {
      enumerable: true,
      value: value,
    });
    /******/ if (mode & 2 && typeof value != "string")
      for (var key in value)
        __webpack_require__.d(
          ns,
          key,
          function (key) {
            return value[key];
          }.bind(null, key),
        );
    /******/ return ns;
    /******/
  };
  /******/
  /******/ // getDefaultExport function for compatibility with non-harmony modules
  /******/ __webpack_require__.n = function (module) {
    /******/ var getter =
      module && module.__esModule
        ? /******/ function getDefault() {
            return module["default"];
          }
        : /******/ function getModuleExports() {
            return module;
          };
    /******/ __webpack_require__.d(getter, "a", getter);
    /******/ return getter;
    /******/
  };
  /******/
  /******/ // Object.prototype.hasOwnProperty.call
  /******/ __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/
  /******/ // __webpack_public_path__
  /******/ __webpack_require__.p = "";
  /******/
  /******/
  /******/ // Load entry module and return exports
  /******/ return __webpack_require__((__webpack_require__.s = 0));
  /******/
})(
  /************************************************************************/
  /******/ [
    /* 0 */
    /***/ function (module, exports) {
      function _slicedToArray(arr, i) {
        return (
          _arrayWithHoles(arr) ||
          _iterableToArrayLimit(arr, i) ||
          _unsupportedIterableToArray(arr, i) ||
          _nonIterableRest()
        );
      }

      function _nonIterableRest() {
        throw new TypeError(
          "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
        );
      }

      function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (
          n === "Arguments" ||
          /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
        )
          return _arrayLikeToArray(o, minLen);
      }

      function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for (var i = 0, arr2 = new Array(len); i < len; i++) {
          arr2[i] = arr[i];
        }
        return arr2;
      }

      function _iterableToArrayLimit(arr, i) {
        if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr)))
          return;
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
          for (
            var _i = arr[Symbol.iterator](), _s;
            !(_n = (_s = _i.next()).done);
            _n = true
          ) {
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
          }
        } catch (err) {
          _d = true;
          _e = err;
        } finally {
          try {
            if (!_n && _i["return"] != null) _i["return"]();
          } finally {
            if (_d) throw _e;
          }
        }
        return _arr;
      }

      function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
      }

      var steps = 8;
      var totalFeatureQuestions = 6;
      var checkedFeatureQuestions = 0;
      var currencyFormatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      var currencyFormatterNoCents = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
      var budget1 = [
        [600, 999],
        [1000, 1499],
        [1500, Number.POSITIVE_INFINITY],
      ];
      var budget2 = [
        [850, 1199],
        [1200, 1999],
        [2000, Number.POSITIVE_INFINITY],
      ];
      var currentBudget;
      var sizeTwin = "twin";
      var sizeTwinXL = "twin-xl";
      var sizeFull = "full";
      var sizeQueen = "queen";
      var sizeKing = "king";
      var sizeCalKing = "cal-king";
      var sizeToBudget = new Map();
      sizeToBudget.set(sizeTwin, budget1);
      sizeToBudget.set(sizeTwinXL, budget1);
      sizeToBudget.set(sizeFull, budget1);
      sizeToBudget.set(sizeQueen, budget1);
      sizeToBudget.set(sizeKing, budget2);
      sizeToBudget.set(sizeCalKing, budget2);
      var yes = "yes";
      var no = "no";
      var noPreference = "no-preference";
      var glideaway = "glideaway";
      var elevation = "elevation";
      var products = [
        {
          name: "Rize Contemporary IV Adjustable Bed",
          handle: "contemporary-iv-adjustable-bed",
          visible: true,
          elevationTilt: true,
          pillowTilt: true,
          lumbarSupport: true,
          voiceCommands: true,
          appControl: true,
          snoreDetection: true,
          wallHugger: false,
          zeroClearance: true,
          massage: true,
          usbPorts: true,
          underbedLighting: true,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: false,
        },
        {
          name: "Rize Remedy III Adjustable Bed",
          handle: "remedy-iii-adjustable-bed",
          visible: true,
          elevationTilt: true,
          pillowTilt: true,
          lumbarSupport: true,
          voiceCommands: true,
          appControl: true,
          snoreDetection: true,
          wallHugger: false,
          zeroClearance: true,
          massage: true,
          usbPorts: true,
          underbedLighting: true,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: false,
        },
        {
          name: "Reverie R650",
          handle: "reverie-r650-adjustable-base",
          visible: true,
          elevationTilt: true,
          pillowTilt: false,
          lumbarSupport: false,
          voiceCommands: false,
          appControl: true,
          snoreDetection: false,
          wallHugger: false,
          zeroClearance: false,
          massage: true,
          usbPorts: false,
          underbedLighting: true,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: false,
        },
        {
          name: "Reverie R400",
          handle: "reverie-r400-power-base",
          visible: true,
          elevationTilt: false,
          pillowTilt: false,
          lumbarSupport: false,
          voiceCommands: false,
          appControl: true,
          snoreDetection: false,
          wallHugger: false,
          zeroClearance: false,
          massage: true,
          usbPorts: false,
          underbedLighting: true,
          presetPositions: true,
          zeroGravity: false,
          basicNoFrillsLowPrice: true,
        },
        {
          name: "Malouf S755 Smart Adjustable Bed Base",
          handle: "malouf-s755-adjustable-base",
          visible: true,
          elevationTilt: false,
          pillowTilt: true,
          lumbarSupport: true,
          voiceCommands: true,
          appControl: true,
          snoreDetection: true,
          wallHugger: true,
          zeroClearance: true,
          massage: true,
          usbPorts: true,
          underbedLighting: true,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: false,
        },
        {
          name: "Malouf S655",
          handle: "malouf-structures-s655-adjustable-bed",
          visible: true,
          elevationTilt: false,
          pillowTilt: true,
          lumbarSupport: false,
          voiceCommands: true,
          appControl: true,
          snoreDetection: true,
          wallHugger: false,
          zeroClearance: true,
          massage: true,
          usbPorts: true,
          underbedLighting: true,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: false,
        },
        {
          name: "Malouf M555",
          handle: "malouf-m555-adjustable-bed",
          visible: true,
          elevationTilt: false,
          pillowTilt: false,
          lumbarSupport: false,
          voiceCommands: true,
          appControl: true,
          snoreDetection: true,
          wallHugger: false,
          zeroClearance: true,
          massage: true,
          usbPorts: true,
          underbedLighting: true,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: false,
        },
        {
          name: "Malouf E455",
          handle: "malouf-structures-e455-adjustable-bed",
          visible: true,
          elevationTilt: false,
          pillowTilt: false,
          lumbarSupport: false,
          voiceCommands: true,
          appControl: true,
          snoreDetection: true,
          wallHugger: false,
          zeroClearance: true,
          massage: false,
          usbPorts: true,
          underbedLighting: false,
          presetPositions: true,
          zeroGravity: false,
          basicNoFrillsLowPrice: true,
        },
        {
          name: "Malouf E255",
          handle: "malouf-structures™-e255-adjustable-base",
          visible: true,
          elevationTilt: false,
          pillowTilt: false,
          lumbarSupport: false,
          voiceCommands: false,
          appControl: false,
          snoreDetection: false,
          wallHugger: false,
          zeroClearance: true,
          massage: false,
          usbPorts: false,
          underbedLighting: false,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: true,
        },
        {
          name: "Malouf N150",
          handle: "malouf-structures™-n150-adjustable-base",
          visible: true,
          elevationTilt: false,
          pillowTilt: false,
          lumbarSupport: false,
          voiceCommands: false,
          appControl: false,
          snoreDetection: false,
          wallHugger: false,
          zeroClearance: true,
          massage: false,
          usbPorts: false,
          underbedLighting: false,
          presetPositions: false,
          zeroGravity: false,
          basicNoFrillsLowPrice: true,
        },
        {
          name: "Ergomotion DUETTO Split Top Adjustable Base",
          handle: "ergomotion-duetto-split-top-adjustable-base",
          visible: true,
          elevationTilt: false,
          pillowTilt: false,
          lumbarSupport: false,
          voiceCommands: false,
          appControl: false,
          snoreDetection: true,
          wallHugger: false,
          zeroClearance: true,
          massage: false,
          usbPorts: true,
          underbedLighting: true,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: false,
        },
        {
          name: "Sealy Ease 4.0",
          handle: "sealy-ease-4-0-adjustable-base",
          visible: true,
          elevationTilt: false,
          pillowTilt: false,
          lumbarSupport: false,
          voiceCommands: false,
          appControl: false,
          snoreDetection: false,
          wallHugger: false,
          zeroClearance: true,
          massage: false,
          usbPorts: false,
          underbedLighting: false,
          presetPositions: false,
          zeroGravity: true,
          basicNoFrillsLowPrice: true,
        },
        {
          name: "TEMPUR-Ergo® ProSmart™ Base",
          handle: "tempur-ergo-prosmart-base",
          visible: true,
          elevationTilt: false,
          pillowTilt: false,
          lumbarSupport: true,
          voiceCommands: false,
          appControl: true,
          snoreDetection: true,
          wallHugger: false,
          zeroClearance: true,
          massage: true,
          usbPorts: true,
          underbedLighting: true,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: false,
        },
        {
          name: "Tempur-Ergo Smart Base",
          handle: "tempur-ergo-smart-base",
          visible: true,
          elevationTilt: false,
          pillowTilt: false,
          lumbarSupport: true,
          voiceCommands: false,
          appControl: true,
          snoreDetection: true,
          wallHugger: false,
          zeroClearance: true,
          massage: true,
          usbPorts: true,
          underbedLighting: true,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: false,
        },
        {
          name: "Tempur-Ergo Power Base 3.0",
          handle: "tempur-ergo-power-base",
          visible: true,
          elevationTilt: false,
          pillowTilt: false,
          lumbarSupport: true,
          voiceCommands: false,
          appControl: false,
          snoreDetection: true,
          wallHugger: false,
          zeroClearance: true,
          massage: true,
          usbPorts: true,
          underbedLighting: true,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: false,
        },
        {
          name: "Dawn House Bed",
          handle: "the-dawn-house-bed",
          visible: true,
          elevationTilt: false,
          pillowTilt: false,
          lumbarSupport: false,
          voiceCommands: true,
          appControl: true,
          snoreDetection: true,
          wallHugger: false,
          zeroClearance: false,
          massage: true,
          usbPorts: false,
          underbedLighting: true,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: false,
        },
        {
          name: "Ergo-Pedic iTilt Incline Therapy Adjustable Bed",
          handle: "ergo-pedic-zenith-tilt-base-adjustable-bed",
          visible: true,
          elevationTilt: true,
          pillowTilt: false,
          lumbarSupport: false,
          voiceCommands: false,
          appControl: true,
          snoreDetection: true,
          wallHugger: true,
          zeroClearance: false,
          massage: true,
          usbPorts: false,
          underbedLighting: true,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: false,
        },
        {
          name: "Bed Planet High Low Lift and Tilt Adjustable Bed",
          handle: "bedplanet-adjustable-base-high-low-lift-bed",
          visible: true,
          elevationTilt: true,
          pillowTilt: false,
          lumbarSupport: false,
          voiceCommands: true,
          appControl: false,
          snoreDetection: false,
          wallHugger: false,
          zeroClearance: false,
          massage: true,
          usbPorts: true,
          underbedLighting: true,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: false,
        },
        {
          name: "Ergomotion Ascend High-Low Adjustable Bed with Tilt",
          handle: "ergomotion-ascend-high-low-adjustable-bed-with-tilt",
          visible: true,
          elevationTilt: true,
          pillowTilt: true,
          lumbarSupport: false,
          voiceCommands: false,
          appControl: false,
          snoreDetection: false,
          wallHugger: false,
          zeroClearance: true,
          massage: false,
          usbPorts: false,
          underbedLighting: true,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: false,
        },
        {
          name: "Ergomotion RIO 1.0 Adjustable Bed",
          handle: "ergomotion-rio-1-0-adjustable-bed",
          visible: true,
          elevationTilt: false,
          pillowTilt: true,
          lumbarSupport: false,
          voiceCommands: false,
          appControl: false,
          snoreDetection: false,
          wallHugger: false,
          zeroClearance: true,
          massage: false,
          usbPorts: false,
          underbedLighting: false,
          presetPositions: false,
          zeroGravity: false,
          basicNoFrillsLowPrice: true,
        },
        {
          name: "Ergomotion RIO 2.0 Adjustable Bed",
          handle: "ergomotion-rio-2-0-adjustable-bed",
          visible: true,
          elevationTilt: false,
          pillowTilt: true,
          lumbarSupport: false,
          voiceCommands: false,
          appControl: false,
          snoreDetection: false,
          wallHugger: false,
          zeroClearance: true,
          massage: false,
          usbPorts: false,
          underbedLighting: false,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: true,
        },
        {
          name: "Ergomotion RIO 3.0 Adjustable Bed",
          handle: "ergomotion-rio-3-0-adjustable-bed",
          visible: true,
          elevationTilt: false,
          pillowTilt: true,
          lumbarSupport: false,
          voiceCommands: false,
          appControl: false,
          snoreDetection: false,
          wallHugger: false,
          zeroClearance: true,
          massage: false,
          usbPorts: false,
          underbedLighting: true,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: true,
        },
        {
          name: "Ergomotion RIO 4.0 Adjustable Bed",
          handle: "ergomotion-rio-4-0-adjustable-bed",
          visible: true,
          elevationTilt: false,
          pillowTilt: true,
          lumbarSupport: false,
          voiceCommands: false,
          appControl: false,
          snoreDetection: false,
          wallHugger: false,
          zeroClearance: true,
          massage: true,
          usbPorts: true,
          underbedLighting: true,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: false,
        },
        {
          name: "Ergomotion RIO 5.0 Adjustable Bed",
          handle: "ergomotion-rio-5-0-adjustable-bed",
          visible: true,
          elevationTilt: false,
          pillowTilt: true,
          lumbarSupport: true,
          voiceCommands: false,
          appControl: true,
          snoreDetection: true,
          wallHugger: true,
          zeroClearance: true,
          massage: true,
          usbPorts: true,
          underbedLighting: true,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: false,
        },
        {
          name: "Ergomotion RIO 6.0 Adjustable Bed",
          handle: "ergomotion-rio-6-0-adjustable-bed",
          visible: true,
          elevationTilt: false,
          pillowTilt: true,
          lumbarSupport: true,
          voiceCommands: false,
          appControl: true,
          snoreDetection: true,
          wallHugger: true,
          zeroClearance: true,
          massage: true,
          usbPorts: true,
          underbedLighting: true,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: false,
        },
        {
          name: "Serta® baselogic™ Silver Adjustable Base",
          handle: "serta®-baselogic™-silver-adjustable-base",
          visible: true,
          elevationTilt: false,
          pillowTilt: true,
          lumbarSupport: false,
          voiceCommands: false,
          appControl: false,
          snoreDetection: false,
          wallHugger: false,
          zeroClearance: true,
          massage: false,
          usbPorts: false,
          underbedLighting: false,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: true,
        },
        {
          name: "Serta® baselogic™ Bronze Adjustable Base",
          handle: "serta®-baselogic™-bronze-adjustable-base",
          visible: true,
          elevationTilt: false,
          pillowTilt: true,
          lumbarSupport: false,
          voiceCommands: false,
          appControl: false,
          snoreDetection: false,
          wallHugger: false,
          zeroClearance: true,
          massage: false,
          usbPorts: false,
          underbedLighting: false,
          presetPositions: false,
          zeroGravity: false,
          basicNoFrillsLowPrice: true,
        },
        {
          name: "Serta® baselogic™ Platinum Adjustable Base",
          handle: "serta®-baselogic™-platinum-adjustable-base",
          visible: true,
          elevationTilt: false,
          pillowTilt: true,
          lumbarSupport: false,
          voiceCommands: false,
          appControl: false,
          snoreDetection: true,
          wallHugger: false,
          zeroClearance: true,
          massage: true,
          usbPorts: true,
          underbedLighting: true,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: false,
        },
        {
          name: "Serta® baselogic™ Gold Adjustable Base",
          handle: "serta®-baselogic-gold-adjustable-base",
          visible: true,
          elevationTilt: false,
          pillowTilt: true,
          lumbarSupport: false,
          voiceCommands: false,
          appControl: false,
          snoreDetection: false,
          wallHugger: false,
          zeroClearance: true,
          massage: true,
          usbPorts: true,
          underbedLighting: true,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: false,
        },
        {
          name: "Bedplanet Model G Adjustable Bed",
          handle: "bedplanet-model-g-adjustable-bed",
          visible: true,
          elevationTilt: false,
          pillowTilt: true,
          lumbarSupport: false,
          voiceCommands: true,
          appControl: false,
          snoreDetection: true,
          wallHugger: true,
          zeroClearance: true,
          massage: true,
          usbPorts: true,
          underbedLighting: true,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: false,
        },
        {
          name: "Bedplanet Model P Adjustable Bed",
          handle: "bedplanet-model-p-adjustable-bed",
          visible: true,
          elevationTilt: false,
          pillowTilt: true,
          lumbarSupport: false,
          voiceCommands: false,
          appControl: false,
          snoreDetection: true,
          wallHugger: false,
          zeroClearance: true,
          massage: true,
          usbPorts: true,
          underbedLighting: true,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: false,
        },
        {
          name: "Bedplanet Model D Adjustable Bed",
          handle: "bedplanet-model-d-adjustable-bed",
          visible: true,
          elevationTilt: false,
          pillowTilt: true,
          lumbarSupport: false,
          voiceCommands: false,
          appControl: false,
          snoreDetection: false,
          wallHugger: false,
          zeroClearance: true,
          massage: false,
          usbPorts: false,
          underbedLighting: false,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: true,
        },
        {
          name: "Bedplanet Sam Adjustable Base with Headboard",
          handle: "bedplanet-sam-adjustable-base-with-headboard",
          visible: true,
          elevationTilt: false,
          pillowTilt: true,
          lumbarSupport: false,
          voiceCommands: false,
          appControl: false,
          snoreDetection: false,
          wallHugger: false,
          zeroClearance: true,
          massage: false,
          usbPorts: false,
          underbedLighting: true,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: false,
        },
        {
          name: "Bedplanet Alex Adjustable Base with Headboard",
          handle: "bedplanet-alex-adjustable-base-with-headboard",
          visible: true,
          elevationTilt: false,
          pillowTilt: true,
          lumbarSupport: false,
          voiceCommands: false,
          appControl: false,
          snoreDetection: false,
          wallHugger: false,
          zeroClearance: true,
          massage: false,
          usbPorts: false,
          underbedLighting: true,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: false,
        },
        {
          name: "Bedplanet Taylor Adjustable Base with Headboard",
          handle: "bedplanet-taylor-adjustable-base-with-headboard",
          visible: true,
          elevationTilt: false,
          pillowTilt: true,
          lumbarSupport: false,
          voiceCommands: false,
          appControl: false,
          snoreDetection: false,
          wallHugger: false,
          zeroClearance: true,
          massage: false,
          usbPorts: false,
          underbedLighting: true,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: false,
        },
        {
          name: "Scott Living Elevate Adjustable Bed Base",
          handle: "scott-living-elevate-adjustable-bed-base",
          visible: true,
          elevationTilt: false,
          pillowTilt: true,
          lumbarSupport: false,
          voiceCommands: false,
          appControl: true,
          snoreDetection: true,
          wallHugger: false,
          zeroClearance: true,
          massage: true,
          usbPorts: true,
          underbedLighting: true,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: false,
        },
        {
          name: "Bedplanet Model H Adjustable Bed",
          handle: "bedplanet-sbkdh-adjustable-base",
          visible: true,
          elevationTilt: false,
          pillowTilt: true,
          lumbarSupport: false,
          voiceCommands: false,
          appControl: false,
          snoreDetection: false,
          wallHugger: false,
          zeroClearance: false,
          massage: false,
          usbPorts: false,
          underbedLighting: false,
          presetPositions: false,
          zeroGravity: false,
          basicNoFrillsLowPrice: true,
        },
        {
          name: "Bedplanet Model L Adjustable Bed",
          handle: "bedplanet-model-l-adjustable-bed",
          visible: true,
          elevationTilt: false,
          pillowTilt: true,
          lumbarSupport: true,
          voiceCommands: false,
          appControl: false,
          snoreDetection: true,
          wallHugger: false,
          zeroClearance: true,
          massage: true,
          usbPorts: true,
          underbedLighting: true,
          presetPositions: true,
          zeroGravity: true,
          basicNoFrillsLowPrice: false,
        },
      ];
      var variants = [];

      function toStandardizedSize(shopifyVariant) {
        var shopifySize = shopifyVariant.option1
          ? shopifyVariant.option1.toLowerCase()
          : "";

        if (shopifySize.includes("twin xl")) {
          // Check Twin XL first
          return sizeTwinXL;
        } else if (shopifySize.includes("twin")) {
          return sizeTwin;
        } else if (shopifySize.includes("full")) {
          return sizeFull;
        } else if (shopifySize.includes("queen")) {
          return sizeQueen;
        } else if (
          shopifySize.includes("king") &&
          shopifySize.includes("cal")
        ) {
          // Check Cal King before King
          return sizeCalKing;
        } else if (shopifySize.includes("king")) {
          return sizeKing;
        } else {
          console.debug(
            "Unable to determine size for "
              .concat(shopifyVariant.option1, " [")
              .concat(shopifyVariant.name, "]"),
          );
          return "";
        }
      }

      function filterProducts(renderResults) {
        var _getSelections = getSelections(),
          size = _getSelections.size,
          budget = _getSelections.budget,
          gerdAcidReflux = _getSelections.gerdAcidReflux,
          snore = _getSelections.snore,
          platformBed = _getSelections.platformBed,
          pillowTilt = _getSelections.pillowTilt,
          lumbarSupport = _getSelections.lumbarSupport,
          wallHugger = _getSelections.wallHugger,
          usbPorts = _getSelections.usbPorts,
          underbedLighting = _getSelections.underbedLighting,
          programmablePositions = _getSelections.programmablePositions; // console.debug('size', size);
        // console.debug('budget', budget);
        // console.debug('gerd/acid reflux', gerdAcidReflux);
        // console.debug('snore', snore);
        // console.debug('platform bed', platformBed);
        // console.debug('pillow tilt', pillowTilt);
        // console.debug('lumbar support', lumbarSupport);
        // console.debug('wall hugger', wallHugger);
        // console.debug('usbPorts', usbPorts);
        // console.debug('underbed lighting', underbedLighting);
        // console.debug('programmable positions', programmablePositions);
        // console.debug('mattress', mattress);

        var filteredVariants = variants.filter(function (variant) {
          return (
            variant.visible &&
            variant.product.visible &&
            size === variant.standardizedSize &&
            inBudget(variant, budget) &&
            matchesGerd(variant, gerdAcidReflux) &&
            ((snore === yes && variant.product.snoreDetection) ||
              snore === no) &&
            ((platformBed === yes && variant.product.zeroClearance) ||
              platformBed === no) &&
            ((pillowTilt === yes && variant.product.pillowTilt) ||
              (pillowTilt === no && !variant.product.pillowTilt) ||
              pillowTilt === noPreference) &&
            ((lumbarSupport === yes && variant.product.lumbarSupport) ||
              (lumbarSupport === no && !variant.product.lumbarSupport) ||
              lumbarSupport === noPreference) &&
            ((wallHugger === yes && variant.product.wallHugger) ||
              (wallHugger === no && !variant.product.wallHugger) ||
              wallHugger === noPreference) &&
            ((usbPorts === yes && variant.product.usbPorts) ||
              (usbPorts === no && !variant.product.usbPorts) ||
              usbPorts === noPreference) &&
            ((underbedLighting === yes && variant.product.underbedLighting) ||
              (underbedLighting === no && !variant.product.underbedLighting) ||
              underbedLighting === noPreference) &&
            ((programmablePositions === yes &&
              variant.product.presetPositions) ||
              (programmablePositions === no &&
                !variant.product.presetPositions) ||
              programmablePositions === noPreference)
          );
        });

        var priceSort = function priceSort(a, b) {
          return b.price - a.price;
        };

        filteredVariants = filteredVariants.sort(priceSort);
        var results = $("#results");
        var resultsContainer = $("#resultsContainer");
        var noResultsContainer = $("#noResultsContainer"); // hide all

        results.addClass("d-none");
        resultsContainer.addClass("d-none");
        noResultsContainer.addClass("d-none");

        if (renderResults) {
          if (filteredVariants.length > 0) {
            var productCards = $();
            filteredVariants.forEach(function (product, i) {
              // eslint-disable-line no-unused-vars
              productCards = productCards.add(createProductCard(product));
            });
            clearProductResults();
            results.append(
              createResultsHeader().add(
                productCards.wrapAll('<div class="row"></div>').parent(),
              ),
            ); // show product results and form

            results.removeClass("d-none");
            resultsContainer.removeClass("d-none"); // scroll results into view

            $([document.documentElement, document.body]).animate(
              {
                scrollTop: results.offset().top,
              },
              200,
            );
          } else {
            // show no results form
            noResultsContainer.removeClass("d-none");
          }
        }
      }

      function inBudget(variant, budget) {
        var price = Math.floor(variant.price);
        return (
          budget === noPreference || (budget[0] <= price && price <= budget[1])
        );
      }

      function matchesGerd(variant, gerdAcidReflux) {
        // Special handling for Glideaway bases as they have the elevation tilt feature
        // as an add-on to conform to the GERD requirement and we cannot directly use
        // the 'elevationTilt' attribute of the product itself
        if (isGlideaway(variant)) {
          var hasElevation = isGlideawayElevation(variant);
          return (
            (gerdAcidReflux === yes && hasElevation) || gerdAcidReflux === no
          );
        } else {
          return (
            (gerdAcidReflux === yes && variant.product.elevationTilt) ||
            gerdAcidReflux === no
          );
        }
      }

      function isGlideawayElevation(variant) {
        return isGlideaway(variant) && isElevation(variant);
      }

      function isGlideaway(variant) {
        return variant.name.toLowerCase().includes(glideaway);
      }

      function isElevation(variant) {
        return variant.name.toLowerCase().includes(elevation);
      }

      function toFormattedBudgetRange(budget) {
        var low = budget[0];
        var high = budget[1];

        if (
          high === Number.POSITIVE_INFINITY ||
          high === Number.POSITIVE_INFINITY.toString()
        ) {
          return "".concat(currencyFormatterNoCents.format(low), " & up");
        } else {
          return ""
            .concat(currencyFormatterNoCents.format(low), " \u2013 ")
            .concat(currencyFormatterNoCents.format(high));
        }
      }

      function updateBudgetOnSizeChange() {
        var _getSelections2 = getSelections(),
          size = _getSelections2.size;

        var newBudget = sizeToBudget.get(size);

        if (newBudget !== currentBudget) {
          var budget1Label = $("label[for=budget1]");
          var budget2Label = $("label[for=budget2]");
          var budget3Label = $("label[for=budget3]");
          budget1Label.text(toFormattedBudgetRange(newBudget[0]));
          budget2Label.text(toFormattedBudgetRange(newBudget[1]));
          budget3Label.text(toFormattedBudgetRange(newBudget[2]));
          var budget1Radio = $("#budget1");
          var budget2Radio = $("#budget2");
          var budget3Radio = $("#budget3");
          budget1Radio.val(
            ""
              .concat(newBudget[0][0].toString(), "-")
              .concat(newBudget[0][1].toString()),
          );
          budget2Radio.val(
            ""
              .concat(newBudget[1][0].toString(), "-")
              .concat(newBudget[1][1].toString()),
          );
          budget3Radio.val(
            ""
              .concat(newBudget[2][0].toString(), "-")
              .concat(newBudget[2][1].toString()),
          );
          budget1Radio.prop("checked", false);
          budget2Radio.prop("checked", false);
          budget3Radio.prop("checked", false);
          currentBudget = newBudget;
        }
      }

      function getSelections() {
        var size = $("#size").val() || sizeKing;
        var selectedBudget =
          $("input[name=budget]:checked").val() || noPreference;
        var budget;

        if (typeof selectedBudget === "string") {
          if (selectedBudget === noPreference) {
            budget = noPreference;
          } else {
            var splitBudget = selectedBudget.split("-");
            budget = [
              parseInt(splitBudget[0]),
              splitBudget[1] === Number.POSITIVE_INFINITY.toString()
                ? Number.POSITIVE_INFINITY
                : parseInt(splitBudget[1]),
            ];
          }
        } else {
          budget = selectedBudget;
        }

        var gerdAcidReflux =
          $("input[name=gerdAcidReflux]:checked").val() || no;
        var snore = $("input[name=snore]:checked").val() || no;
        var platformBed = $("input[name=platformBed]:checked").val() || no;
        var pillowTilt =
          $("input[name=pillowTilt]:checked").val() || noPreference;
        var lumbarSupport =
          $("input[name=lumbarSupport]:checked").val() || noPreference;
        var wallHugger =
          $("input[name=wallHugger]:checked").val() || noPreference;
        var usbPorts = $("input[name=usbPorts]:checked").val() || noPreference;
        var underbedLighting =
          $("input[name=underbedLighting]:checked").val() || noPreference;
        var programmablePositions =
          $("input[name=programmablePositions]:checked").val() || noPreference;
        var mattress = $("input[name=mattress]:checked").val() || no;
        return {
          size: size,
          budget: budget,
          gerdAcidReflux: gerdAcidReflux,
          snore: snore,
          platformBed: platformBed,
          pillowTilt: pillowTilt,
          lumbarSupport: lumbarSupport,
          wallHugger: wallHugger,
          usbPorts: usbPorts,
          underbedLighting: underbedLighting,
          programmablePositions: programmablePositions,
          mattress: mattress,
        };
      }

      function createResultsHeader() {
        var template = [
          '<div class="row">',
          '  <div class="col ml-3 pb-2">',
          "    <h5>Matching Adjustable Bases</h5>",
          "    <p>Based on your preferences we think you'll like the following adjustable bases.</p>",
          "  </div>",
          "</div>",
        ];
        return $(template.join(""));
      }

      function createProductCard(variant) {
        var financing = "";
        var financeTerm = getFinancing(variant);

        if (financeTerm > 0) {
          financing =
            "0% Interest Only <strong>" +
            currencyFormatterNoCents.format(
              Math.ceil(variant.price / financeTerm),
            ) +
            "</strong>/month";
        }

        var template = [
          '<div class="col-md-4 mb-5 pl-3 pr-3">',
          '  <div class="row">',
          '    <div class="col">', // Comment this line when deployed to BedPlanet
          // '      <a href="https://bedplanet.com' + variant.product.url + '?variant=' + variant.id + '">',
          // Comment this line when running locally or deployed to S3
          '      <a href="' +
            variant.product.url +
            "?variant=" +
            variant.id +
            '">',
          '        <img src="' +
            variant.thumbnail +
            '" class="rounded mx-auto d-block" alt="' +
            variant.product.name +
            '" style="width: 225px; height: 225px;">',
          "      </a>",
          "    </div>",
          "  </div>",
          '  <div class="row">',
          '    <div class="col text-center">',
          "      <strong>" + variant.product.name + "</strong>",
          "    </div>",
          "  </div>",
          '  <div class="row">',
          '    <div class="col text-center">',
          variant.size,
          "    </div>",
          "  </div>",
          '  <div class="row">',
          '    <div class="col text-center">',
          currencyFormatter.format(variant.price),
          financing.length > 0 ? "<br>" : "",
          financing,
          "    </div>",
          "  </div>",
          "</div>",
        ];
        return $(template.join(""));
      } // same as finance_months

      function getFinancing(variant) {
        // eslint-disable-line no-unused-vars
        // const price = chair.price || 0;
        // if (price >= 1999 && price < 8990) {
        //     return 48;
        // } else if (price >= 8990) {
        //     return 60;
        // } else {
        //     return -1;
        // }
        // TODO: for now return false
        return false;
      }

      function clearProductResults() {
        var results = $("#results");
        results.html("");
      }

      function nextStep() {
        var nextStep = $("#wizard").smartWizard("getStepIndex") + 1;

        if (nextStep < steps) {
          $("#wizard").smartWizard("goToStep", nextStep);
        }
      }

      function checkForNextStep() {
        var previousCheckedFeatureQuestions = checkedFeatureQuestions;
        var checkedSelectors = [];

        for (
          var _len = arguments.length, names = new Array(_len), _key = 0;
          _key < _len;
          _key++
        ) {
          names[_key] = arguments[_key];
        }

        names.forEach(function (name) {
          return checkedSelectors.push("[name=" + name + "]:checked");
        });
        checkedFeatureQuestions = $(checkedSelectors.join(",")).length;
        var allChecked = checkedFeatureQuestions === names.length;

        if (
          allChecked &&
          previousCheckedFeatureQuestions < totalFeatureQuestions
        ) {
          // If all of the feature questions are checked and we previously had less
          // than all of the feature questions checked then advance to the next step.
          // This is to prevent it advancing to the next step when a user goes back
          // to this page with all of the questions checked and then changes a selection
          nextStep();
        }
      }

      function resetForm() {
        checkedFeatureQuestions = 0;
        $("#wizard").smartWizard("reset");
        $("#size").prop("selectedIndex", 0);
        $("input[name=budget]").prop("checked", false);
        $("input[name=gerdAcidReflux]").prop("checked", false);
        $("input[name=snore]").prop("checked", false);
        $("input[name=platformBed]").prop("checked", false);
        $("input[name=pillowTilt]").prop("checked", false);
        $("input[name=lumbarSupport]").prop("checked", false);
        $("input[name=wallHugger]").prop("checked", false);
        $("input[name=usbPorts]").prop("checked", false);
        $("input[name=underbedLighting]").prop("checked", false);
        $("input[name=programmablePositions]").prop("checked", false);
        $("input[name=mattress]").prop("checked", false);
        $("#noResultsForm")[0].reset(); // TODO: Clear Bootstrap validation
        // $('#noResultsForm').data('bootstrapValidator').resetForm();
        // $('#noResultsForm').removeClass('was-validated');
      }

      window.resetForm = resetForm;
      /**
       * Accepts either a URL or querystring and returns an object associating
       * each querystring parameter to its value.
       *
       * Returns an empty object if no querystring parameters found.
       */

      function getUrlParams(urlOrQueryString) {
        if ((i = urlOrQueryString.indexOf("?")) >= 0) {
          // eslint-disable-line no-undef
          var queryString = urlOrQueryString.substring(i + 1); // eslint-disable-line no-undef

          if (queryString) {
            return _mapUrlParams(queryString);
          }
        }

        return {};
      }
      /**
       * Helper function for `getUrlParams()`
       * Builds the querystring parameter to value object map.
       *
       * @param queryString {string} - The full querystring, without the leading '?'.
       */

      function _mapUrlParams(queryString) {
        return queryString
          .split("&")
          .map(function (keyValueString) {
            return keyValueString.split("=");
          })
          .reduce(function (urlParams, _ref) {
            var _ref2 = _slicedToArray(_ref, 2),
              key = _ref2[0],
              value = _ref2[1];

            if (Number.isInteger(parseInt(value)) && parseInt(value) == value) {
              urlParams[key] = parseInt(value);
            } else {
              urlParams[key] = decodeURI(value);
            }

            return urlParams;
          }, {});
      }

      $(document).ready(function () {
        // Redirect if contact form has been submitted (i.e. `?form_type=contact`)
        // Any value for this parameter will suffice
        var urlParams = getUrlParams(location.search);

        if (Object.prototype.hasOwnProperty.call(urlParams, "form_type")) {
          window.location = "/pages/thank-you-for-your-submission";
        }

        $("select[name=size]").change(function (e) {
          // eslint-disable-line no-unused-vars
          updateBudgetOnSizeChange();
          nextStep();
        });
        $("input[type=radio][name=budget]").change(function (e) {
          // eslint-disable-line no-unused-vars
          nextStep();
        });
        $("input[type=radio][name=gerdAcidReflux]").change(function (e) {
          // eslint-disable-line no-unused-vars
          nextStep();
        });
        $("input[type=radio][name=snore]").change(function (e) {
          // eslint-disable-line no-unused-vars
          nextStep();
        });
        $("input[type=radio][name=platformBed]").change(function (e) {
          // eslint-disable-line no-unused-vars
          nextStep();
        });
        $("input[type=radio][name=pillowTilt]").change(function (e) {
          // eslint-disable-line no-unused-vars
          checkForNextStep(
            "pillowTilt",
            "lumbarSupport",
            "wallHugger",
            "usbPorts",
            "underbedLighting",
            "programmablePositions",
          );
        });
        $("input[type=radio][name=lumbarSupport]").change(function (e) {
          // eslint-disable-line no-unused-vars
          checkForNextStep(
            "pillowTilt",
            "lumbarSupport",
            "wallHugger",
            "usbPorts",
            "underbedLighting",
            "programmablePositions",
          );
        });
        $("input[type=radio][name=wallHugger]").change(function (e) {
          // eslint-disable-line no-unused-vars
          checkForNextStep(
            "pillowTilt",
            "lumbarSupport",
            "wallHugger",
            "usbPorts",
            "underbedLighting",
            "programmablePositions",
          );
        });
        $("input[type=radio][name=usbPorts]").change(function (e) {
          // eslint-disable-line no-unused-vars
          checkForNextStep(
            "pillowTilt",
            "lumbarSupport",
            "wallHugger",
            "usbPorts",
            "underbedLighting",
            "programmablePositions",
          );
        });
        $("input[type=radio][name=underbedLighting]").change(function (e) {
          // eslint-disable-line no-unused-vars
          checkForNextStep(
            "pillowTilt",
            "lumbarSupport",
            "wallHugger",
            "usbPorts",
            "underbedLighting",
            "programmablePositions",
          );
        });
        $("input[type=radio][name=programmablePositions]").change(function (e) {
          // eslint-disable-line no-unused-vars
          checkForNextStep(
            "pillowTilt",
            "lumbarSupport",
            "wallHugger",
            "usbPorts",
            "underbedLighting",
            "programmablePositions",
          );
        });
        $("input[type=radio][name=mattress]").change(function (e) {
          // eslint-disable-line no-unused-vars
          nextStep();
        });
        var btnReset = $("<button></button>")
          .text("Start Over")
          .addClass("btn btn-danger")
          .click(function () {
            resetForm();
          }); // Step show event

        $("#wizard").on(
          "showStep",
          function (e, anchorObject, stepNumber, stepDirection, stepPosition) {
            $("#prev-btn").removeClass("disabled");
            $("#next-btn").removeClass("disabled");

            if (stepPosition === "first") {
              $("#prev-btn").addClass("disabled");
            } else if (stepPosition === "last") {
              $("#next-btn").addClass("disabled");
            } else {
              $("#prev-btn").removeClass("disabled");
              $("#next-btn").removeClass("disabled");
            }

            if (stepPosition === "last") {
              // last step
              filterProducts(true);
            } else {
              clearProductResults();
              var results = $("#results");
              var resultsContainer = $("#resultsContainer");
              var noResultsContainer = $("#noResultsContainer"); // hide all

              results.addClass("d-none");
              resultsContainer.addClass("d-none");
              noResultsContainer.addClass("d-none");
            }
          },
        ); // Smart Wizard

        $("#wizard").smartWizard({
          selected: 0,
          enableURLhash: false,
          theme: "arrows",
          // default, arrows, dots, progress
          transition: {
            animation: "fade", // Effect on navigation, none/fade/slide-horizontal/slide-vertical/slide-swing
          },
          toolbarSettings: {
            toolbarPosition: "bottom",
            toolbarExtraButtons: [btnReset],
          },
          autoAdjustHeight: false,
        }); // External Button Events

        $("#reset-btn").click(function () {
          // Reset wizard
          $("#wizard").smartWizard("reset");
          return true;
        });
        $("#prev-btn").click(function () {
          // Navigate previous
          $("#wizard").smartWizard("prev");
          return true;
        });
        $("#next-btn").click(function () {
          // Navigate next
          $("#wizard").smartWizard("next");
          return true;
        });
        $("#resultsForm").submit(function (event) {
          // eslint-disable-line no-unused-vars
          var _getSelections3 = getSelections(),
            size = _getSelections3.size,
            budget = _getSelections3.budget,
            gerdAcidReflux = _getSelections3.gerdAcidReflux,
            snore = _getSelections3.snore,
            platformBed = _getSelections3.platformBed,
            pillowTilt = _getSelections3.pillowTilt,
            lumbarSupport = _getSelections3.lumbarSupport,
            wallHugger = _getSelections3.wallHugger,
            usbPorts = _getSelections3.usbPorts,
            underbedLighting = _getSelections3.underbedLighting,
            programmablePositions = _getSelections3.programmablePositions,
            mattress = _getSelections3.mattress;

          $("#resultsSize").val(size);
          $("#resultsBudget").val(budget);
          $("#resultsGerdAcidReflux").val(gerdAcidReflux);
          $("#resultsSnore").val(snore);
          $("#resultsPlatformBed").val(platformBed);
          $("#resultsPillowTilt").val(pillowTilt);
          $("#resultsLumbarSupport").val(lumbarSupport);
          $("#resultsWallHugger").val(wallHugger);
          $("#resultsUsb").val(usbPorts);
          $("#resultsUnderbedLighting").val(underbedLighting);
          $("#resultsProgrammablePositions").val(programmablePositions);
          $("#resultsNeedMattress").val(mattress);
          return true;
        });
        $("#noResultsForm").submit(function (event) {
          // eslint-disable-line no-unused-vars
          var _getSelections4 = getSelections(),
            size = _getSelections4.size,
            budget = _getSelections4.budget,
            gerdAcidReflux = _getSelections4.gerdAcidReflux,
            snore = _getSelections4.snore,
            platformBed = _getSelections4.platformBed,
            pillowTilt = _getSelections4.pillowTilt,
            lumbarSupport = _getSelections4.lumbarSupport,
            wallHugger = _getSelections4.wallHugger,
            usbPorts = _getSelections4.usbPorts,
            underbedLighting = _getSelections4.underbedLighting,
            programmablePositions = _getSelections4.programmablePositions,
            mattress = _getSelections4.mattress;

          $("#noResultsSize").val(size);
          $("#noResultsBudget").val(budget);
          $("#noResultsGerdAcidReflux").val(gerdAcidReflux);
          $("#noResultsSnore").val(snore);
          $("#noResultsPlatformBed").val(platformBed);
          $("#noResultsPillowTilt").val(pillowTilt);
          $("#noResultsLumbarSupport").val(lumbarSupport);
          $("#noResultsWallHugger").val(wallHugger);
          $("#noResultsUsb").val(usbPorts);
          $("#noResultsUnderbedLighting").val(underbedLighting);
          $("#noResultsProgrammablePositions").val(programmablePositions);
          $("#noResultsNeedMattress").val(mattress);
          return true;
        });
        products.forEach(function (product, index, productArray) {
          // Comment this line when deployed to BedPlanet
          // $.getJSON('https://bedplanet.com/products/' + product.handle + '.js', function(shopifyProduct) {
          // Comment this line when running locally or deployed to S3
          $.getJSON(
            "/products/" + product.handle + ".js",
            function (shopifyProduct) {
              productArray[index].name = shopifyProduct.title || product.name;
              productArray[index].price = shopifyProduct.price / 100;
              productArray[index].url = shopifyProduct.url;
              productArray[index].thumbnail = shopifyProduct.featured_image;
              productArray[index].visible = shopifyProduct.available;

              if (
                Object.prototype.hasOwnProperty.call(
                  shopifyProduct,
                  "variants",
                ) &&
                shopifyProduct.variants
              ) {
                shopifyProduct.variants.forEach(
                  function (shopifyVariant, variantIndex) {
                    // eslint-disable-line no-unused-vars
                    var variant = {
                      id: shopifyVariant.id,
                      name: shopifyVariant.name,
                      price: shopifyVariant.price / 100,
                      size: shopifyVariant.option1,
                      standardizedSize: toStandardizedSize(shopifyVariant),
                      thumbnail:
                        Object.prototype.hasOwnProperty.call(
                          shopifyProduct,
                          "featured_image",
                        ) && shopifyVariant.featured_image
                          ? shopifyVariant.featured_image.src
                          : product.thumbnail,
                      sku: shopifyVariant.sku,
                      visible: shopifyVariant.available,
                      product: productArray[index],
                    };
                    variants.push(variant);
                  },
                );
              }
            },
          );
        });
      }); // Restricts input for the set of matched elements to the given inputFilter function.

      (function ($) {
        $.fn.inputFilter = function (inputFilter) {
          return this.on(
            "input keydown keyup mousedown mouseup select contextmenu drop",
            function () {
              if (inputFilter(this.value)) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
              } else if (
                Object.prototype.hasOwnProperty.call(this, "oldValue")
              ) {
                this.value = this.oldValue;
                this.setSelectionRange(
                  this.oldSelectionStart,
                  this.oldSelectionEnd,
                );
              } else {
                this.value = "";
              }
            },
          );
        };
      })(jQuery);

      (function () {
        "use strict";

        window.addEventListener(
          "load",
          function () {
            // Fetch all the forms we want to apply custom Bootstrap validation styles to
            var forms = document.getElementsByClassName("needs-validation"); // Loop over them and prevent submission

            var validation = Array.prototype.filter.call(
              forms,
              function (form) {
                // eslint-disable-line no-unused-vars
                form.addEventListener(
                  "submit",
                  function (event) {
                    if (form.checkValidity() === false) {
                      event.preventDefault();
                      event.stopPropagation();
                    }

                    form.classList.add("was-validated");
                  },
                  false,
                );
              },
            );
          },
          false,
        );
      })();

      /***/
    },
    /******/
  ],
);
